/**
 * ios webview 橡皮筋效果开关
 * @param {bool} close
 */
export default function appToPage(params) {
    try {
        window.CSNativeObject.jumpToNative(JSON.stringify(params));
    }
    catch (error) { }
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/app/appToPage.js
// module id = null
// module chunks = 